
import React from "react";
import { useParams } from "react-router-dom";
import Contracts from "../Contract/Contracts";
import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Helper function to capitalize first letter of each word
const toProperCase = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const Dashboard = () => {
  const { type } = useParams();
  const documentType = type || "contract";
  
  document.title = `${toProperCase(documentType)}s | ONFON GROUP LEGAL - React Dashboard`;
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Onfon" breadcrumbItem={`${toProperCase(documentType)}s`} />          
          <Row>
            <Contracts isHome={false}/>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
